if ($('.leen-widget-js').length !== 0) {
    var data = {};

    function setRente(newRente) {
        $("#laagsteRente").data('rente', newRente);
        $("#laagsteRente").text(newRente);
    }

    function getCurrentRente() {

        return parseFloat($("#laagsteRente").data('rente'));
    }

    function setMaandlast() {

        var leenbedrag = getLeningbedrag();
        var rentePerJaar = convertRenteToPerMonth(getCurrentRente() / 100);
        var looptijdInMaanden = parseInt($("#looptijd").data("looptijd"));
        var maandlast = getMaandlastFromInterest(leenbedrag, getCurrentRente(), looptijdInMaanden);
        // var andereMaandlast = getMaandlastFromInterest(leenbedrag, getCurrentRente(), looptijdInMaanden);
        // console.log(leenbedrag, rentePerJaar, looptijdInMaanden, maandlast, andereMaandlast);

        maandlastFiscaalVoordeel = ((looptijdInMaanden * maandlast - ((looptijdInMaanden * maandlast - leenbedrag) * 0.42)) / looptijdInMaanden);

        $("#maandlast").text(Number(maandlast).toLocaleString("nl-NL", {maximumFractionDigits: 2,minimumFractionDigits: 2}));
        $("#maandlastFiscaalVoordeel").text(Number(maandlastFiscaalVoordeel).toLocaleString("nl-NL", {maximumFractionDigits: 2,minimumFractionDigits: 2}));
        $("#maandlast").data('maandlast', maandlast);
        $("#lening_berekenen").attr('action', 'https://nederlandskredietcollectief.nl/offerte-aanvragen/?leenbedrag=' + leenbedrag);
    }

    function getLeningbedrag() {

        return parseFloat($("#leningbedrag").val());
    }

    function getMaandlastFromInterest(leenbedrag, rente, looptijd)
    {
        var nominaal = (Math.pow((1 + rente / 100),(1 / 12)) - 1) * 100;

       return annu(leenbedrag, (nominaal/100), looptijd).toFixed(2);
    }

    function calculateMaandlast(leenBedrag, rentePerMaand, looptijdInMaanden) {

        var waarde = (rentePerMaand / (1 - Math.pow((1 + rentePerMaand), -looptijdInMaanden))) * leenBedrag;
        return waarde;
    }

    function annu(bedrag, rentevoet, periode){

        waarde = (rentevoet / (1 - Math.pow((1+rentevoet), -periode))) * bedrag;
        return waarde;
    }

    function convertRenteToPerMonth(rentePerJaar) {

        return (Math.pow((1 + (rentePerJaar / 100)),(1 / 12)) - 1);
    }

    function getLooptijd() {

        return parseInt($("#looptijd").data('looptijd'));
    }

    function getZelfstandig() {
        return ($('#lening_berekenen').data('rubriek-is-zelfstandig') === 'ja');
    }

    function calculateData() {

        if($('#leningbedrag').val() < 15000 && $("#looptijd").data('looptijd') > 120)
        {
            $("#looptijd").data('looptijd', 120);
            $('#looptijd').text('120 mnd');
        }
        else if($('#leningbedrag').val() > 15000 && $("#looptijd").data('default-looptijd') > 120){
            $("#looptijd").data('looptijd', $("#looptijd").data('default-looptijd'));
            $('#looptijd').text($("#looptijd").data('default-looptijd') + ' mnd');
        }

        var ajaxdata = JSON.stringify({
            'productvorm' : 'persoonlijke lening',
            'leenbedrag' : getLeningbedrag(),
            'looptijd' : getLooptijd(),
            'zelfstandig' : getZelfstandig(),
        });

        $.ajax({
            url: '/rentetarieven/getDataForLeenwidget/',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: ajaxdata,
            success: function(data) {
                setRente(data);
                setMaandlast();
            },
        });
    }

    function showExtraInfo(){
        if(!$('#extra-info-loanslider').is(':visible')){
            $('#extra-info-loanslider').show(0);
            $('.show-extra-info-loanslider').hide();
            $('#show-more-arrow').hide();
            $('#leenWidget').addClass('more-info-visible');
            $('.belastingVoordeel').show();
        }
    }

    $(document).ready(function() {

        if($('#lening_berekenen').length > 0) {
            var numberFormatEuroOptions = { // format euro options
                numberOfDecimals: 0,
                decimalSeparator: ',',
                thousandSeparator: '.'
            };
        }

        $('#lening_berekenen').find('input[type="text"]').click(function() {

            $(this).select();
        });

        $('#lening_berekenen').find('input[type="radio"]').on('click', function() {

                var id = $(this).data('holder'); //haal het id van het corresponderende veld op dat de data moet vasthouden
                $('input#' + id).val($(this).val()); //stel de juiste waarde in van dit veld
                calculateData(); //verwerk alle data
            });

        $("#leningbedrag").on('blur', function () {

            var bedrag = getLeningbedrag();
            var slider = $("#leningSlider").data("ionRangeSlider");
            if (isNaN(bedrag)){
                bedrag = 5000;
            }else if (bedrag < slider.options.min) {
                bedrag = slider.options.min;
            }else if (bedrag > slider.options.max) {
                bedrag = slider.options.max;
            }
            $("#leningbedrag").val(bedrag);
            slider.update({from: bedrag});
            calculateData();
            showExtraInfo();
        });

        setSlider = function (elem, min, max, startVal, step, callback) {

            min = typeof min == 'undefined' ? 5000 : Number(min);
            max = typeof max == 'undefined' ? 75000 : Number(max);
            startVal = typeof startVal == 'undefined' ? 0 : Number(startVal);
            step = typeof step == 'undefined' ? 0 : Number(step);
            parentElem = elem.parent().attr('class');

            elem.ionRangeSlider({
                from: startVal,
                min: min,
                max: max,
                step: step,
                onStart: function(data) {
                    dataHolder = $(data.input[0]).data('holder');
                    $('input[id="'+dataHolder+'"]').val(data.from);
                    $(parentElem + ' .rails').css({backgroundPosition: '0 -6px'});
                },
                onChange: function(data) {
                    dataHolder = $(data.input[0]).data('holder');
                    $('input[id="'+dataHolder+'"]').val(data.from);
                    // calculateData();
                    showExtraInfo();
                },
                onFinish: function(data) {
                    calculateData();
                }
            });
        };


        $('#lening_berekenen').find('.slider').each(function(index, el) {

            setSlider(
                $(this),
                $(this).attr('min'),
                $(this).attr('max'),
                $(this).attr('start-val'),
                $(this).attr('step'));
        });

        $('.show-extra-info-loanslider a').on('click',function(e){
            e.preventDefault();
            showExtraInfo();
        });
    });

    $(window).load(function() {

        calculateData();
    });
}